module.exports = __webpack_public_path__ + "static/media/4pic.b95546c3.png";